import { ref } from "vue";
import global from "@/global";

export function usePostAnswer({ uri, headers, skipAutoFetch = true }) {
  const fetchedData = ref(null);
  const fetchError = ref(null);
  const requestBody = ref({});
  const queryParam = ref("");

  const post = async () => {
    try {
      const res = await fetch(`${global.API_URL}${uri}${queryParam.value}`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody.value),
      });

      fetchedData.value = await res.json();
    } catch (err) {
      fetchError.value = err;
    }
  };

  !skipAutoFetch && post();

  return { post, fetchedData, fetchError, requestBody, queryParam };
}
